import { useSelector } from 'react-redux'

import { QuestionFieldNames } from 'src/model/card'

import { cardSettingPatch, cardSettingCreate } from 'src/reducers/card/action'

export function useCard() {
  //refactor
  const baseEntity = useSelector(state => state.card.currentCard)
  return baseEntity
}

export function useCardSettings(key) {
  const card = useCard()
  if (!card) return
  const settings = card[QuestionFieldNames.SETTING_DTOS]

  if (!key) return settings

  const setting = settings.find(x => x.key === key)
  return setting
}

export function patchSetting(dispatch, cardId, id, key, value, callback) {
  dispatch(
    cardSettingPatch(
      {
        path: 'Value',
        value: value,
      },
      id,
      cardId,
      key,
      () => {
        if (callback) {
          callback()
        }
      },
    ),
  )
}

export function createSetting(dispatch, cardId, key, value, callback) {
  dispatch(
    cardSettingCreate(
      {
        cardId: cardId,
        key: key,
        value: value,
      },
      cardId,
      () => {
        if (callback) callback()
      },
    ),
  )
}
